export default "__VITE_ASSET__WzHcC8Z6__"